exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".PreRace section.PreRaceIntro {\n  opacity: 1;\n  -webkit-transition: opacity 0.25s;\n  -o-transition: opacity 0.25s;\n  transition: opacity 0.25s; }\n  .PreRace section.PreRaceIntro.Hide {\n    opacity: 0; }\n  .PreRace section.PreRaceIntro .Text {\n    text-align: center;\n    font-size: 1.25rem; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/pages/Phases/PreRace/PreRace.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/pages/Phases/PreRace/PreRace.css
// module chunks = 0